import { render, staticRenderFns } from "./FlagTag.vue?vue&type=template&id=15fb25e0&lang=pug"
import script from "./FlagTag.vue?vue&type=script&lang=ts"
export * from "./FlagTag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports